import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import {
  DashboardTableData,
  DashboardTableConfig,
  DashboardUserData,
} from '../../../models';
import { CardListComponent } from '../card-list/card-list.component';

@Component({
  selector: 'app-dashboard-table',
  standalone: true,
  imports: [CommonModule, RouterLink, CardListComponent],
  templateUrl: './dashboard-table.component.html',
  styleUrl: './dashboard-table.component.scss',
})
export class DashboardTableComponent {
  @Input() data: DashboardTableData[] | DashboardUserData[] = [];
  @Input() config!: DashboardTableConfig;
  @Input() type: 'documents' | 'users' = 'documents';
  @Output() documentNameClick = new EventEmitter<DashboardTableData>();

  getStatusColor(status: string): string {
    switch (status) {
      case 'Pending':
        return 'bg-yellow-500';
      case 'Approved':
        return 'bg-green-500';
      case 'Rejected':
        return 'bg-red-500';
      case 'Reviewed':
      case 'Viewed':
        return 'bg-blue-500';
      case 'Responded':
        return 'bg-green-500';
      default:
        return 'bg-gray-500';
    }
  }

  get userData(): DashboardUserData[] {
    return this.type === 'users' ? (this.data as DashboardUserData[]) : [];
  }

  get documentData(): DashboardTableData[] {
    return this.type === 'documents' ? (this.data as DashboardTableData[]) : [];
  }

  onDocumentNameClick(row: DashboardTableData): void {
    this.documentNameClick.emit(row);
  }
}
